// Starter templates, seeded once into the Templates notebook (edit or delete them like any note).
// Placeholders filled on insert: {{date}} {{time}} {{project}} {{task}} {{title}} (shared/notes.js fillTemplate).
const todo = (...items) => `<ul data-type="taskList">${(items.length ? items : ['']).map((t) => `<li data-type="taskItem" data-checked="false"><p>${t}</p></li>`).join('')}</ul>`;
const table = (head, rows = 3) => `<table><tbody><tr>${head.map((h) => `<th><p>${h}</p></th>`).join('')}</tr>${
  Array.from({ length: rows }, () => `<tr>${head.map(() => '<td><p></p></td>').join('')}</tr>`).join('')}</tbody></table>`;

export const NOTE_TEMPLATES = [
  {
    title: 'Daily log', icon: '📅',
    html: `<h2>{{date}}</h2><h3>Plan</h3>${todo()}<h3>Done</h3><p></p><h3>Problems / found</h3><p></p><h3>Tomorrow</h3>${todo()}`
      + '<div data-callout="tip"><p>Type /Today’s log to drop in the clocked hours, what got done and focus.</p></div>',
  },
  {
    title: 'Site visit', icon: '📍',
    html: '<p><strong>Project:</strong> {{project}}</p><p><strong>Date:</strong> {{date}} · {{time}}</p><p><strong>Address:</strong> </p><p><strong>On site:</strong> </p>'
      + `<h3>Measurements</h3>${table(['Item', 'Measure', 'Note'])}<h3>What I saw</h3><p></p><h3>Photos</h3><p></p><h3>To do</h3>${todo()}`,
  },
  {
    title: 'Client call', icon: '📞',
    html: '<p><strong>Who:</strong> </p><p><strong>When:</strong> {{date}} · {{time}}</p><p><strong>Project:</strong> {{project}}</p>'
      + `<h3>What they want</h3><p></p><h3>Budget / timing</h3><p></p><h3>Next steps</h3>${todo('Send quote', 'Book site visit')}`,
  },
  {
    title: 'Estimate notes', icon: '🧮',
    html: `<p><strong>Project:</strong> {{project}} · {{date}}</p><h3>Scope</h3><p></p><h3>Materials</h3>${table(['Item', 'Qty', 'Unit', 'Note'], 4)}`
      + '<h3>Labour</h3><p></p><h3>Exclusions</h3><ul><li><p></p></li></ul><h3>Questions for the client</h3><ul><li><p></p></li></ul>'
      + '<div data-callout="warning"><p>Check the notes, assembly layers and consultant sheets — the model is not the scope.</p></div>',
  },
  {
    title: 'Meeting', icon: '🤝',
    html: `<p><strong>Date:</strong> {{date}} · {{time}}</p><p><strong>Who:</strong> </p><h3>Agenda</h3><ul><li><p></p></li></ul><h3>Decisions</h3><p></p><h3>Action items</h3>${todo()}`,
  },
];
